"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equals = void 0;
const number_1 = require("../number");
const eqBoolean = (a, b) => a.value === b.value;
const eqDate = (a, b) => a.year === b.year && a.month === b.month && a.day === b.day;
const eqMonth = (a, b) => a.value === b.value;
const eqNumber = (a, b) => {
    if (a.unit != null) {
        if (b.unit == null || a.unit.type !== b.unit.type) {
            return false;
        }
    }
    else if (b.unit != null) {
        return false;
    }
    return (0, number_1.toBaseUnit)(a).equals((0, number_1.toBaseUnit)(b));
};
const eqRecord = (a, b) => {
    if (a.elements.size !== b.elements.size) {
        return false;
    }
    for (const [key, value] of a.elements) {
        const otherValue = b.elements.get(key);
        if (otherValue == null || !(0, exports.equals)(value, otherValue)) {
            return false;
        }
    }
    return true;
};
const eqString = (a, b) => a.value === b.value;
const eqTime = (a, b) => a.hour === b.hour && a.minute === b.minute && a.second === b.second;
const eqVector = (a, b) => {
    if (a.elements.length !== b.elements.length) {
        return false;
    }
    for (let i = 0; i < a.elements.length; ++i) {
        if (!(0, exports.equals)(a.elements[i], b.elements[i])) {
            return false;
        }
    }
    return true;
};
const eqWeekday = (a, b) => a.value === b.value;
const equals = (a, b) => {
    if (a.type === b.type) {
        switch (a.type) {
            case "Boolean":
                return eqBoolean(a, b);
            case "Date":
                return eqDate(a, b);
            case "Month":
                return eqMonth(a, b);
            case "Number":
                return eqNumber(a, b);
            // TODO: case "Quote":
            case "Record":
                return eqRecord(a, b);
            case "String":
                return eqString(a, b);
            case "Time":
                return eqTime(a, b);
            case "Vector":
                return eqVector(a, b);
            case "Weekday":
                return eqWeekday(a, b);
        }
    }
    return false;
};
exports.equals = equals;
